export default function () {
    let stickyHeader = function () {
        let header = jQuery('#header');

        if (jQuery(window).scrollTop() > 1) {
            header.addClass('sticky');

            jQuery('.js-mega-menu--toggle').removeClass('active');
            jQuery('header').addClass('mega-menu-opened');
            jQuery('.js-mega-menu--container').hide(300);
        } else {
            header.removeClass('sticky');
        }
    };

    let didScroll;
    let lastScrollTop = 0;
    let delta = 1;
    let navbarHeight = jQuery('.header--site').outerHeight();

    jQuery(window).scroll(function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        let st = jQuery(document).scrollTop();

        if (Math.abs(lastScrollTop - st) <= delta) return;

        if (st > lastScrollTop && st > navbarHeight) {
            jQuery('.header--site').removeClass('nav-down').addClass('nav-up');
        } else {
            if (st + jQuery(window).height() < jQuery(document).height()) {
                jQuery('.header--site').removeClass('nav-up').addClass('nav-down');
            }
        }

        lastScrollTop = st;
    }

    window.addEventListener('load', stickyHeader);
    window.addEventListener('scroll', stickyHeader);
    window.addEventListener('resize', stickyHeader);
}
